import Label from "@material-ui/icons/Label";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import ArrowRightIcon from "@material-ui/icons/ArrowRight";
import TreeChild from "./TreeChild";
import { StyledTreeView } from "./styles.js/Tree";
import { useDoubleTap } from "use-double-tap";

let node = 1;

const TreeItem = ({ branch, action = () => {}, ...props }) => {
  const bind = useDoubleTap((event) => action(branch));

  return (
    <TreeChild
      key={branch.id}
      nodeId={(node++).toString()}
      labelText={branch.descricao}
      labelInfo={branch.codigo}
      labelIcon={Label}
      informations={branch}
      style={{ marginLeft: 25 }}
      {...bind}
    />
  );
};

const Tree = ({
  defaultExpanded = ["1"],
  branches = [],
  action = () => {},
  ...props
}) => {
  /**
   * TODO
   * Padronizar como o array vem construido pra ser consumido
   * no componente
   * @param {Array} branches
   * @returns TreeChild
   */
  const branchesView = (elements) => {
    return elements.map((branch) =>
      branch.ativo === "S" && branch.filhos.length ? (
        <TreeChild
          nodeId={(node++).toString()}
          key={branch.id}
          labelText={branch.descricao}
          labelInfo={branch.codigo}
          labelIcon={Label}
          style={{ marginLeft: 25 }}
        >
          {branchesView(branch.filhos)}
        </TreeChild>
      ) : (
        branch.ativo === "S" && (
          <TreeItem key={branch.id} branch={branch} action={action} />
        )
      )
    );
  };

  return (
    <StyledTreeView
      defaultExpanded={defaultExpanded}
      defaultCollapseIcon={<ArrowDropDownIcon />}
      defaultExpandIcon={<ArrowRightIcon />}
    >
      {branchesView(branches)}
    </StyledTreeView>
  );
};

export default Tree;
